<template>
    <div class="box box-primary">

        <div class="box-header with-border">
            <h3 class="box-title">Filter</h3>
            <div class="box-tools pull-right">
                <button
                    class="btn btn-box-tool"
                    title="Collapse"
                    type="button"
                    @click="toggleCollapse"
                >
                    <i
                        :class="changeIcon(collapse)"
                        class="fa"
                    ></i>
                </button>
            </div>
        </div>

        <vue-slide-up-down
            :active="collapse"
            :duration="durationCollapse"
        >
            <div class="box-body">
                <div class="row">
                    <div class="col-xs-12 col-lg-12">
                        <form
                            action=""
                            method="get"
                            role="form"
                            @submit.prevent="newQueryURL"
                        >
                            <div class="row">
                                <div class="form-group form-group col-lg-4 col-md-6 col-xs-12">
                                    <label>{{ $t('name') }}</label>
                                    <input
                                        v-model="search"
                                        :placeholder="`${$t('enter')} ${$t('name')}`"
                                        class="form-control"
                                        type="text"
                                    />
                                </div>
                                <div class="form-group form-group col-lg-4 col-md-6 col-xs-12">
                                    <label>{{ $t('sourceNumber') }}</label>
                                    <input
                                        v-model="sourceNumber"
                                        :placeholder="`${$t('sourceNumber')}`"
                                        class="form-control"
                                        type="text"
                                    />
                                </div>
                                <div class="form-group col-xs-12 col-sm-4 col-lg-4">
                                    <label class="col-xs-12 hidden-xs">&nbsp;</label>
                                    <button
                                        class="btn btn-sm btn-primary"
                                        type="submit"
                                    >
                                        Apply
                                    </button>
                                    <a
                                        :href="getPath()"
                                        class="btn btn-sm btn-info"
                                        @click.prevent="clearFilter"
                                    >
                                        Clear
                                    </a>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </vue-slide-up-down>
    </div>
</template>
<script>
import EventBus from '@/event-bus';

export default {
    data() {
        return {
            collapse: false,
            durationCollapse: 700,
            search: '',
            sourceNumber: '',
        };
    },
    mounted() {
        if (this.$route.query['filter[search]']) {
            this.search = this.$route.query['filter[search]'];
            this.collapse = true;
        }

        if (this.$route.query['filter[sourceNumber]']) {
            this.sourceNumber = this.$route.query['filter[sourceNumber]'];
            this.collapse = true;
        }
    },
    methods: {
        newQueryURL() {
            let query = {
                page: 1,
            };

            if (this.search) {
                query['filter[search]'] = this.search;
            }

            if (this.sourceNumber) {
                query['filter[sourceNumber]'] = this.sourceNumber;
            }

            this.$router.push({
                path: this.getPath(),
                query,
            }).catch(() => {});

            EventBus.$emit('relodList');
        },
        clearFilter() {
            this.search = '';
            this.sourceNumber = '';
            this.newQueryURL();
        },
        getPath() {
            return this.$route.path;
        },
        changeIcon(value) {
            return value ? 'fa-minus' : 'fa-plus';
        },
        toggleCollapse() {
            this.collapse = !this.collapse;
        },
    }
}
</script>
